import Vue from 'vue'
import {
  Button, Form, Field, Toast,PullRefresh,NoticeBar,Empty,Swipe,SwipeItem,Image,Lazyload,Dialog,Circle, Popover
} from 'vant'

Vue.use(Button)
Vue.use(Form)
Vue.use(Field)
Vue.use(Toast)
Vue.use(PullRefresh)
Vue.use(NoticeBar)
Vue.use(Empty)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(Lazyload)
Vue.use(Circle)
Vue.use(Popover)

Toast.setDefaultOptions({ duration: 2000 });
